import { create } from "zustand";

type SaveChangesState = {
  isOpen: boolean;
  pendingAction: null | ((actionType: Number) => void);

  openModal: (action: (actionType: Number) => void) => void;
  confirm: (actionType: Number) => void;
  cancel: () => void;
};

export const useSaveQuestionChangeStore = create<SaveChangesState>(
  (set, get) => ({
    isOpen: false,
    pendingAction: null,

    openModal: (action) =>
      set({
        isOpen: true,
        pendingAction: action,
      }),

    confirm: (actionType: Number) => {
      const action = get().pendingAction;
      if (action) action(actionType);

      set({
        isOpen: false,
        pendingAction: null,
      });
    },

    cancel: () =>
      set({
        isOpen: false,
        pendingAction: null,
      }),
  })
);
